module.exports = __webpack_public_path__ + "static/media/jaehyun-8.jpeg";